const log = {
    invalid_type: '日誌類型無效。',
    invalid_time_window: '`end_time` 必須晚於 `start_time`。',
};
export default Object.freeze(log);
